import React from 'react';
import { Link } from 'react-router-dom';
import { NUMEROLOGY_URL } from "../config";

export const Header = () => {
  return (
    <header className="header-nav">
      <div className="container">
        <div className="flex items-center justify-between w-full">
          <Link to="/" className="flex items-center gap-2">
            <img
              src="/logo-desyclare.png"
              alt="Desy Clare Logo"
              className="h-8 w-8 object-contain"
            />
            <span className="heading-3 font-semibold">Desy Clare</span>
          </Link>
          
          <nav className="hidden md:flex items-center gap-6">
            <Link to="/" className="body-medium hover:text-amber-600 transition-colors">
              Home
            </Link>
            <Link to="/info" className="body-medium hover:text-amber-600 transition-colors">
              Info
            </Link>
            {/*<Link to="/numerology" className="body-medium hover:text-amber-600 transition-colors">
              Numerology
            </Link>*/}
            {/* Ganti Link ke a */}
            <a href={NUMEROLOGY_URL} className="body-medium hover:text-amber-600 transition-colors">
              Numerologi
            </a>
            <Link to="/contact\" className="body-medium hover:text-amber-600 transition-colors">
              Hubungi Kami
            </Link>
          </nav>
          
          <a href={NUMEROLOGY_URL} className="btn-primary">
            Mulai Sekarang
          </a>
        </div>
      </div>
    </header>
  );
};